import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

const TextareaD1 = ({
	className,
	label,
	readOnly,
	textareaClasses = "",
	placeholder,
	type,
	size,
	...props
}) => {
	const classes = cx(
		'form-field',
		`form-field--${size}`,
		className
	);

	return (
		<div className={classes}>
			{label && (
				<label className="form-field__label">{label}</label>
			)}
			<textarea
				className={`form-field__textarea !rounded-[10px] ${textareaClasses}`}
				readOnly={readOnly}
				{...{ placeholder, type }}
				{...props}
			/>
		</div>
	);
};

TextareaD1.propTypes = {
	label: PropTypes.string,
	type: PropTypes.oneOf(["text", "password"]),
	className: PropTypes.string,
	textareaClasses: PropTypes.string,
	placeholder: PropTypes.string,
	readOnly: PropTypes.bool,
	size: PropTypes.oneOf(["default", "large", "small"]),
};

TextareaD1.defaultProps = {
	label: "",
	placeholder: "",
	type: "text",
	className: '',
	textareaClasses: '',
	readOnly: false,
	size: "default",
};

export default TextareaD1;
